compiler('[filter-checkboxes-on-change]', (element) => {
    const checkBoxName = element.getAttribute('filter-checkboxes-on-change');
    const filterByAttribute =  element.getAttribute('filter-checkboxes-by');
    const checkBoxSelector = '[name="' + checkBoxName + '"][type="checkbox"]';

    element.addEventListener('change', (event) => {
        const filterValue = element.options[element.selectedIndex].getAttribute(filterByAttribute);
        const filterSelector = '[' + filterByAttribute + '="' + filterValue + '"]';

        let options_to_hide = document.querySelectorAll(checkBoxSelector + ':not(' + filterSelector + ')');
        let options_to_show = document.querySelectorAll(checkBoxSelector + filterSelector);

        options_to_hide.forEach((option) => {
            option.checked = false;
            // checkboxes should be grouped with label
            option.parentNode.hidden = true;
        })
        options_to_show.forEach((option) => {
            option.parentNode.hidden = false;
        })
    });

    // filter initially
    element.dispatchEvent(new Event('change'));
})
